import { computed, Injectable, signal } from '@angular/core';
import { UserProfileResult } from '../../interfaces/dashboard';
import { AccountRole } from '../enums';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private _user = signal<UserProfileResult | null>(null);

  readonly user = this._user.asReadonly();
  readonly role = computed<AccountRole | null>(() => this._user()?.accountRole ?? null);
  readonly isLoaded = computed(() => this._user() !== null);

  setUser(profile: UserProfileResult): void {
    this._user.set(profile);
  }

  updateProfileImage(userId: number, imageUrl: string | null): void {
    this._user.update(user => user?.id === userId ? { ...user, imageUrl } : user);
  }

  clear(): void {
    this._user.set(null);
  }
}
